import { render, staticRenderFns } from "./distributionset.vue?vue&type=template&id=5b8807a3&"
import script from "./distributionset.vue?vue&type=script&lang=js&"
export * from "./distributionset.vue?vue&type=script&lang=js&"
import style0 from "./distributionset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports